import { SessionStorageService } from '@df/browser/storage/session-storage.service';
import { ProcessorService } from '@df/ng/processor.service';
/**
 * Globarl storage decorator.
 *
 * ```typescript
 * class someClass {
 *     @SessionStorage('someVariable')
 *     someProperty;
 * }
 * ```
 */
export function SessionStorage(key: string) {
    let service: SessionStorageService;
    const getService = (): SessionStorageService => {
        if (!service) {
            service = ProcessorService.injector.get(SessionStorageService);
        }
        return service;
    };
    return function (target: any, propertyKey: string | symbol) {
        Object.defineProperty(target, propertyKey, {
            get: () => getService().get(key),
            set: (value: any) => getService().set(key, value)
        });
    };
}
